module.exports = __webpack_public_path__ + "static/media/hockey_rink.4c3afc99.svg";